import { Router} from '@angular/router';
import { inject, Injectable } from '@angular/core';
import { APP_ROUTE_PATH } from 'src/app/core/enums';
import { ACCOUNT_ROUTE_PATH } from 'src/app/core/enums/routes/account-route-path.enum';
import { SERVICE_ROUTE_PATH } from 'src/app/core/enums/routes/service-route-path.enum';
import { ServiceRedirectPort } from '@features/service/domain/port/service-redirect.port';
import { INFORMATIVE_ROUTE_PATH } from '@core/enums/routes/informative-route-path.enum';

@Injectable({providedIn: 'root'})
export class ServiceRedirectAdapter implements ServiceRedirectPort {
  private readonly router = inject(Router);

  goToProducts(): void {
    this.router.navigate(
      [`${APP_ROUTE_PATH.service}/${SERVICE_ROUTE_PATH.account}/${ACCOUNT_ROUTE_PATH.products}`],
      {replaceUrl: true}
    );
  }

  goToServiceConfiguration(): void {
    this.router.navigate(
      [`${APP_ROUTE_PATH.serviceConfiguration}`],
      {replaceUrl: true}
    );
  }

  goToInfoDrawers(): void {
    this.router.navigate(
      [`${APP_ROUTE_PATH.info}/${INFORMATIVE_ROUTE_PATH.drawers}`],
      {replaceUrl: true}
    );
  }

  goToInfoLocations(): void {
    this.router.navigate(
      [`${APP_ROUTE_PATH.info}/${INFORMATIVE_ROUTE_PATH.locations}`],
      {replaceUrl: true}
    );
  }

  goToInfoService(): void {
    this.router.navigate(
      [`${APP_ROUTE_PATH.info}/${INFORMATIVE_ROUTE_PATH.service}`],
      {replaceUrl: true}
    );
  }
  
  goToInfoDevice(): void {
    this.router.navigate(
      [`${APP_ROUTE_PATH.info}/${INFORMATIVE_ROUTE_PATH.device}`],
      {replaceUrl: true}
    );
  }

  goToInfoWorkers(): void {
    this.router.navigate(
      [`${APP_ROUTE_PATH.info}/${INFORMATIVE_ROUTE_PATH.workers}`],
      {replaceUrl: true}
    );
  }
}
